import type { DeckAttachWall, DeckBoardType, DeckConfig, DeckJoistDimension, DeckShape, SaunaDimensions } from '../../engines/types';

interface DeckPresetDefinition {
  shape: DeckShape;
  icon: string;
  defaultDepth: number;
  defaultWidth: number | null;
  defaultArmDepth?: number;
  defaultArmWidth?: number;
  defaultWrapDepth?: number;
}

export const DECK_PRESETS: Record<DeckShape, DeckPresetDefinition> = {
  rectangular: {
    shape: 'rectangular',
    icon: '▬',
    defaultDepth: 2,
    defaultWidth: null,
  },
  'l-shape': {
    shape: 'l-shape',
    icon: '⌐',
    defaultDepth: 2,
    defaultWidth: null,
    defaultArmDepth: 1.5,
    defaultArmWidth: 1.5,
  },
  'wrap-front': {
    shape: 'wrap-front',
    icon: '⊓',
    defaultDepth: 1.5,
    defaultWidth: null,
    defaultWrapDepth: 1,
  },
  'wrap-sides': {
    shape: 'wrap-sides',
    icon: '⊔',
    defaultDepth: 1.5,
    defaultWidth: null,
    defaultWrapDepth: 2,
  },
};

const DEFAULT_DECK_ATTACH_WALL: DeckAttachWall = 'front';
const DEFAULT_DECK_BOARD_TYPE: DeckBoardType = '28x120';
const DEFAULT_DECK_JOIST_DIMENSION: DeckJoistDimension = '45x145';

function roundTenth(value: number): number {
  return Math.round(value * 10) / 10;
}

function resolveDefaultWidth(shape: DeckShape, saunaDimensions: SaunaDimensions): number {
  const preset = DECK_PRESETS[shape];
  return roundTenth(preset.defaultWidth ?? saunaDimensions.width);
}

export function createDeckPreset(
  shape: DeckShape,
  saunaDimensions: SaunaDimensions,
  attachWall: DeckAttachWall = DEFAULT_DECK_ATTACH_WALL,
): DeckConfig {
  const preset = DECK_PRESETS[shape];

  return {
    shape,
    attachWall,
    depth: preset.defaultDepth,
    width: resolveDefaultWidth(shape, saunaDimensions),
    boardType: DEFAULT_DECK_BOARD_TYPE,
    joistDimension: DEFAULT_DECK_JOIST_DIMENSION,
    ...(preset.defaultArmDepth !== undefined ? { armDepth: preset.defaultArmDepth } : {}),
    ...(preset.defaultArmWidth !== undefined ? { armWidth: preset.defaultArmWidth } : {}),
    ...(preset.defaultWrapDepth !== undefined ? { wrapDepth: preset.defaultWrapDepth } : {}),
  };
}

